import { fromJS } from 'immutable'
import {
  OPEN_RESPONSE_MODAL_ACCOUNTING,
  SET_KEYWORD_SEARCH_ACCOUNTING,
  SET_AP_FILTER,
  SET_AR_FILTER,
} from '../../actions/accounting-dashboard/types'

const init = fromJS({
  keywordSearch: '',
  responseModal: {
    isOpen: false,
    res: {},
  },
  apFilter: {
    deliveryStateDate: null,
    deliveryEndDate: null,
    dueStartDate: null,
    dueEndDate: null,
    status: 0,
  },
  arFilter: {
    dueStartDate: null,
    dueEndDate: null,
    status: 0,
  },
})

export default (state = init, action) => {
  switch (action.type) {
    case OPEN_RESPONSE_MODAL_ACCOUNTING:
      return state
        .set('responseModal', action.payload.responseModal)
    case SET_KEYWORD_SEARCH_ACCOUNTING:
      return state
        .set('keywordSearch', action.payload.keywordSearch)
    case SET_AP_FILTER:
      return state
        .set('apFilter', action.payload.apFilter)
    case SET_AR_FILTER:
      return state
        .set('arFilter', action.payload.arFilter)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accounting-dashboard/accounting-reducer.js